import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

export const getAdminHeaders = () => ({
  "X-Admin-Password": sessionStorage.getItem("vortex_admin_pass") || "",
});

export default api;
